// components/modals/AddEditReservationModal.jsx
import React from 'react';
import styles from '../components/ReservationTable.module.css';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const AddEditReservationModal = ({
  isOpen,
  onClose,
  currentReservation,
  formData,
  onInputChange,
  onSubmit,
  availableRoomTypes = [],
  availableMealPlans = []
}) => {
  if (!isOpen) return null;

  const handleDownloadFormPdfInternal = () => {
    const input = document.getElementById('reservationForm');
    if (!input) {
      alert('Reservation form content not found for PDF generation.');
      return;
    }

    const originalOverflowY = input.style.overflowY;
    const originalMaxHeight = input.style.maxHeight;

    input.style.overflowY = 'visible';
    input.style.maxHeight = 'none';

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      const filename = formData.name ? `Reservation_Form_${formData.name}.pdf` : 'Reservation_Form.pdf';
      pdf.save(filename);
    }).finally(() => {
      input.style.overflowY = originalOverflowY;
      input.style.maxHeight = originalMaxHeight;
    });
  };

  return (
    <div className={styles.modalOverlay}>
      <div id="reservationForm" className={styles.modalContent}>
        <button className={styles.modalCloseButton} onClick={onClose}>&times;</button>
        <h3 style={{ marginBottom: '20px', fontSize: '20px', fontWeight: '600', color: '#111827' }}>
          {currentReservation ? 'Edit Booking' : 'Add New Booking'}
        </h3>

        <div className={styles.formColumns}>
          {/* Guest Name */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Guest Name</label>
            <input
              name="name"
              value={formData.name || ''}
              onChange={onInputChange}
              type="text"
              className={styles.modalInput}
              placeholder="Enter guest name"
            />
          </div>

          {/* Phone Number */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Phone Number</label>
            <input
              name="phone"
              value={formData.phone || ''}
              onChange={onInputChange}
              type="text"
              className={styles.modalInput}
              placeholder="Enter phone number"
            />
          </div>

          {/* Check-in */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Check-in Date & Time</label>
            <input
              name="checkIn"
              value={formData.checkIn || ''}
              onChange={onInputChange}
              type="datetime-local"
              className={styles.modalInput}
            />
          </div>

          {/* Check-out */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Check-out Date & Time</label>
            <input
              name="checkOut"
              value={formData.checkOut || ''}
              onChange={onInputChange}
              type="datetime-local"
              className={styles.modalInput}
            />
          </div>

          {/* Guests */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Number of Guests</label>
            <input
              name="guests"
              value={formData.guests || ''}
              onChange={onInputChange}
              type="number"
              className={styles.modalInput}
              placeholder="Enter number of guests"
            />
          </div>

          {/* Room Type */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Room Type</label>
            <select
              name="roomType"
              value={formData.roomType || ''}
              onChange={onInputChange}
              className={styles.modalSelect}
            >
              <option value="">Select Room Type</option>
              {availableRoomTypes.map((room, idx) => (
                <option key={idx} value={room}>{room}</option>
              ))}
            </select>
          </div>

          {/* Meal Plan */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Meal Plan</label>
            <select
              name="mealPlan"
              value={formData.mealPlan || ''}
              onChange={onInputChange}
              className={styles.modalSelect}
            >
              <option value="">Select Meal Plan</option>
              {availableMealPlans.map((meal, idx) => (
                <option key={idx} value={meal}>{meal}</option>
              ))}
            </select>
          </div>

          {/* Status */}
          <div className={styles.formField}>
            <label className={styles.modalLabel}>Status</label>
            <select
              name="status"
              value={formData.status || ''}
              onChange={onInputChange}
              className={styles.modalSelect}
            >
              <option value="">Select Status</option>
              <option value="Booked">Booked</option>
              <option value="Checked In">Checked In</option>
              <option value="Checked Out">Checked Out</option>
              <option value="Cancelled">Cancelled</option>
              <option value="New">New</option>
            </select>
          </div>
        </div>

        {/* Special Request */}
        <div style={{ marginBottom: '16px', marginTop: '16px', width: '100%' }}>
          <label className={styles.modalLabel}>Special Request</label>
          <textarea
            name="specialRequest"
            value={formData.specialRequest || ''}
            onChange={onInputChange}
            className={styles.modalTextarea}
            placeholder="Enter any special requests"
          />
        </div>

        {/* Buttons */}
        <div className={styles.modalButtonsContainer}>
          <button onClick={onClose} className={styles.modalCancelBtn}>Cancel</button>
          <button onClick={onSubmit} className={styles.modalSaveBtn}>Save</button>
          <button onClick={handleDownloadFormPdfInternal} className={styles.downloadFormButton}>
            Download Form as PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditReservationModal;